import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { BlogPost, CmsUiDynamicContentQuery, CmsUiDynamicContentService, PageMeta } from '@lobos/library';
import { Observable } from 'rxjs';
import { first, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { AlternateVersion } from '../../../../../services/alternate-version';

@AlternateVersion()
@PageMeta<BlogPageComponent>({
  provide: (self: BlogPageComponent) =>
    self.blogPost$.pipe(
      first(),
      map((blogPost: BlogPost) => ({ title: blogPost.title, description: blogPost.description })),
    ),
})
@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss'],
})
export class BlogPageComponent {
  public blogPost$: Observable<BlogPost>;

  private id: number | undefined;

  constructor(
    protected route: ActivatedRoute,
    protected cmsService: CmsUiDynamicContentService,
    protected cmsQuery: CmsUiDynamicContentQuery,
  ) {
    this.blogPost$ = this.route.paramMap.pipe(
      map((param: ParamMap) => +param.get('id')!),
      tap((id: number) => (this.id = id)),
      switchMap((id: number) => this.cmsService.getBlogPost(id)),
      switchMap(() => this.cmsQuery.blog(this.id!)),
      shareReplay(1),
    );
  }
}
